export default __webpack_public_path__ + "static/cab-companey-0cc6ae7c66808ec4521205aaea915e2a.svg";